module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_59.9e49db72.mp3";